import { render, staticRenderFns } from "./TaxReturnSelfEmploymentSection.vue?vue&type=template&id=5eb0f8c6&scoped=true&"
import script from "./TaxReturnSelfEmploymentSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnSelfEmploymentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb0f8c6",
  null
  
)

export default component.exports